import { SET_SHOW_MODAL } from 'store/actions/leaveTable';
import { SET_MODAL_RESPONSE } from 'store/actions/leaveTable';
import { RESET_MODAL } from 'store/actions/leaveTable';

const initialState = {};

function leaveTable(state = initialState, action) {
    const { payload, type } = action;
    switch (type) {
        case SET_SHOW_MODAL:
            return {
                ...state,
                showModal: { ...state.showModal, ...payload },
                modalResponse: null,
            };
        case SET_MODAL_RESPONSE:
            return {
                ...state,
                modalResponse: state.showModal,
                showModal: null,
            };
        case RESET_MODAL:
            return {
                modalResponse: null,
                showModal: null,
            };
        default:
            return state;
    }
}

export default leaveTable;
